import { IconButton } from "@mui/material";
import { setMode } from "toolkits/redux/setting";
import { useDispatch, useSelector } from "react-redux";

import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import NightsStayRoundedIcon from "@mui/icons-material/NightsStayRounded";
// ----------------------------------------------------------------------

export default function ThemePopover() {
  const dispatch = useDispatch();
  const { mode } = useSelector((state) => state.setting);

  const changeTheme = () => {
    if (mode === "light") {
      dispatch(setMode("dark"));
    } else {
      dispatch(setMode("light"));
    }
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={changeTheme}
        sx={{ color: "#fff", bgcolor: "action.hover" }}
      >
        {mode === "light" ? (
          <NightsStayRoundedIcon fontSize="small" color="inherit" />
        ) : (
          <LightModeRoundedIcon fontSize="small" color="inherit" />
        )}
      </IconButton>
    </>
  );
}
